module.exports = __webpack_public_path__ + "img/kh_ewm@2x.6f1fdcf5.png";